/* Open Road Product Quote — Design D, "The Quote Sheet".
   Ported from the initBench()/initGallery() functions in
   prototypes/components/product-detail/product-detail-page-designs.html,
   trimmed to what Design D actually uses.

   Deliberately NOT ported: the prototype's shared initBench() also drove
   Design C's sticky-buy bar and its firm/optional price toggle
   (.buildprice rewritten to a firm price on standard decors, "from" on
   optional ones). Design D has neither — there is no sticky bar, and the
   price line always reads "from {{ product.price | money }}" regardless
   of decor (these are made to order; see the section's Liquid/schema
   comments) — so .buildprice is never touched by this file.

   Every element lookup is guarded so a hidden decor bench (show_decor_bench
   off) or a missing gallery thumbnail strip never throws, and the page
   stays a plain, submittable HTML form with JS disabled — only the
   contact[finish] hidden field stays empty in that case. */
(function () {
  'use strict';

  function initBench(root) {
    var bench = root.querySelector('.bench');
    if (!bench) return;

    var grid = bench.querySelector('.bench__grid');
    if (!grid) return;

    var nameEl = bench.querySelector('.bench__name');
    var idxEl = bench.querySelector('.bench__idx');
    var noteEl = bench.querySelector('.bench__note');
    var tierEl = bench.querySelector('.bench__tier');
    var sheetFinish = root.querySelector('.qsheet__finish');
    var sheetFinishInput = root.querySelector('.qsheet__finish-input');

    function choose(sw) {
      if (!sw) return;

      var prev = grid.querySelector('.sw.is-chosen');
      if (prev) prev.classList.remove('is-chosen');
      sw.classList.add('is-chosen');

      var optional = sw.getAttribute('data-tier') === 'optional';
      var name = sw.getAttribute('data-name') || '';

      if (nameEl) nameEl.textContent = name;
      if (idxEl) idxEl.textContent = '№ ' + (sw.getAttribute('data-idx') || '');
      if (noteEl) noteEl.textContent = sw.getAttribute('data-note') || '';
      if (tierEl) tierEl.textContent = optional ? 'Optional board · surcharge might apply' : 'Standard board · included';

      /* Written the same moment as the bench detail box, so the chosen
         decor always reaches both the visible confirmation and the
         hidden field the form actually submits. */
      if (sheetFinish) sheetFinish.textContent = name + (optional ? ' · surcharge might apply' : ' · included');
      if (sheetFinishInput) sheetFinishInput.value = name;
    }

    grid.addEventListener('click', function (e) {
      var sw = e.target.closest && e.target.closest('.sw');
      if (sw) choose(sw);
    });

    var tabs = bench.querySelectorAll('.bench__tab');
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].addEventListener('click', function (tab) {
        return function () {
          var fam = tab.getAttribute('data-family');
          for (var j = 0; j < tabs.length; j++) {
            tabs[j].classList.toggle('is-on', tabs[j] === tab);
          }
          var swatches = grid.querySelectorAll('.sw');
          for (var k = 0; k < swatches.length; k++) {
            var match = !fam || swatches[k].getAttribute('data-family') === fam;
            swatches[k].style.display = match ? '' : 'none';
          }
        };
      }(tabs[i]));
    }

    /* Default to the first STANDARD-tier swatch, not simply the first
       swatch in the grid — opening on an optional decor would put a
       "surcharge might apply" note in front of the customer before
       they've chosen anything. */
    choose(grid.querySelector('.sw[data-tier="standard"]') || grid.querySelector('.sw'));
  }

  function initGallery(root) {
    var gal = root.querySelector('.gal');
    if (!gal) return;

    var main = gal.querySelector('.gal__main img');
    var thumbs = gal.querySelector('.gal__thumbs');
    if (!main || !thumbs) return;

    thumbs.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('img');
      if (!t) return;
      main.setAttribute('src', t.getAttribute('data-full') || t.getAttribute('src'));
      var imgs = thumbs.querySelectorAll('img');
      for (var i = 0; i < imgs.length; i++) {
        imgs[i].classList.toggle('is-on', imgs[i] === t);
      }
    });
  }

  var roots = document.querySelectorAll('.or-product-quote');
  for (var i = 0; i < roots.length; i++) {
    initBench(roots[i]);
    initGallery(roots[i]);
  }
})();
